'use client';

import { queryOptions, useSuspenseQuery, UseSuspenseQueryResult } from '@tanstack/react-query';
import { faqsOptions } from '@/api/queries/faqs';
import { FAQDTO } from '@/types/models';
export function useFaqs(realm: 'fundraiser_request' | 'site'): UseSuspenseQueryResult<FAQDTO[]> {
  return useSuspenseQuery(queryOptions(faqsOptions(realm)));
}